import { TrendingUp, TrendingDown } from "lucide-react";

// Hex per accent — used for the colorful-card background/border/icon tint (see `colorful` prop).
const ACCENT_HEX = {
    indigo: "#4F46E5",
    emerald: "#10B981",
    rose: "#EF4444",
    amber: "#F59E0B",
    sky: "#0EA5E9",
    violet: "#8B5CF6",
};

export default function StatCard({ label, value, sublabel, accent = "indigo", icon: Icon, trend, testid, compact = false, colorful = false }) {
    const accentMap = {
        indigo: "bg-indigo-50 text-indigo-600",
        emerald: "bg-emerald-50 text-emerald-600",
        rose: "bg-rose-50 text-rose-600",
        amber: "bg-amber-50 text-amber-600",
        sky: "bg-sky-50 text-sky-600",
        violet: "bg-violet-50 text-violet-600",
    };
    const hex = ACCENT_HEX[accent] || ACCENT_HEX.indigo;
    // `compact` only shrinks the card on mobile widths (< sm) — sm/lg breakpoints
    // render identically to the non-compact card either way.
    // `colorful` tints the whole card background/border with the accent color (opt-in,
    // so other StatCard usages like Subscriptions.jsx keep their plain white card).
    return (
        <div
            data-testid={testid}
            style={colorful ? { backgroundColor: `${hex}14`, borderColor: `${hex}30` } : undefined}
            className={`card-elev rounded-2xl transition-all hover:-translate-y-0.5 ${compact ? "p-3 sm:p-6" : "p-6"}`}
        >
            <div className={`flex items-start justify-between gap-1.5 ${compact ? "mb-1.5 sm:mb-4" : "mb-4"}`}>
                <span className={`min-w-0 font-bold uppercase tracking-[0.16em] text-slate-500 ${compact ? "text-[9px] sm:text-xs truncate" : "text-xs"}`}>{label}</span>
                {Icon ? (
                    <span
                        style={colorful ? { backgroundColor: `${hex}26`, color: hex } : undefined}
                        className={`flex-shrink-0 rounded-xl grid place-items-center ${colorful ? "" : (accentMap[accent] || accentMap.indigo)} ${compact ? "w-6 h-6 sm:w-9 sm:h-9" : "w-9 h-9"}`}
                    >
                        <Icon className={compact ? "w-3 h-3 sm:w-4 sm:h-4" : "w-4 h-4"} />
                    </span>
                ) : null}
            </div>
            <div className={`font-display font-extrabold tracking-tight text-slate-900 ${compact ? "text-lg sm:text-3xl truncate" : "text-3xl"}`}>
                {value}
            </div>
            <div className={`flex items-center gap-1.5 ${compact ? "mt-0.5 sm:mt-1.5 text-[10px] sm:text-sm" : "mt-1.5 text-sm"}`}>
                {trend !== undefined && trend !== null ? (
                    <span className={`inline-flex items-center gap-1 font-semibold ${trend >= 0 ? "text-emerald-600" : "text-rose-600"}`}>
                        {trend >= 0 ? <TrendingUp className="w-3.5 h-3.5" /> : <TrendingDown className="w-3.5 h-3.5" />}
                        {Math.abs(trend).toFixed(1)}%
                    </span>
                ) : null}
                {sublabel ? <span className={`text-slate-500 ${compact ? "truncate" : ""}`}>{sublabel}</span> : null}
            </div>
        </div>
    );
}
